import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { SYSTEM_TYPES } from '#constants/legalSystems';

import { actions } from './actions';
import { TARGETS } from './constants';

const initialState = {
  [TARGETS.SETTINGS]: {},
  [TARGETS.SERVER_ERROR]: false,
  [TARGETS.SCRAPER_HEALTH]: {
    systems: {
      [SYSTEM_TYPES.PJN]: { isUp: true },
      [SYSTEM_TYPES.MEV]: { isUp: true },
      [SYSTEM_TYPES.EJE]: { isUp: true }
    },
    downSystems: [],
    isHealthy: true,
    checkedAt: null
  }
};

const completedState = completeState(initialState);

const reducerDescription = {
  primaryActions: [actions.GET_SETTINGS, actions.GET_SCRAPER_HEALTH],
  override: {
    [actions.SET_SERVER_ERROR]: onReadValue()
  }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
